module.exports = __webpack_public_path__ + "img/master_icon.5b91f5ad.png";